var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGroup = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 15,
  height: 23,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#888",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.25,
  d: "M5.671 20.25h3.734M5.671 22.084h3.734M14.071 7.417c0-3.584-2.986-6.471-6.645-6.416-3.407.055-6.29 2.832-6.421 6.178-.084 2.21.98 4.18 2.65 5.39.691.504 1.074 1.32 1.074 2.163v2.53c0 .734.42 1.146.933 1.146h3.733a.93.93 0 0 0 .934-.916v-2.76c0-.834.364-1.65 1.054-2.145 1.624-1.164 2.679-3.043 2.679-5.179zM7.538 10.168v8.25M5.671 8.334l1.867 1.833M9.405 8.334l-1.867 1.833"
})));
export default SvgGroup;